import routerOptions0 from "D:/Project/vue/frontend_new/node_modules/.pnpm/nuxt@3.8.2_@parcel+watcher@2.4.1_@types+node@18.19.23_encoding@0.1.13_eslint@8.57.0_idb-keyva_hodxbhe4krkirbev4s6yultzwa/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}